import { useAtomValue } from 'jotai'
import { favoritesChannelAtom } from '@/atoms/invalidation'
import { toFavoriteRelays } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { loadFavoriteRelays } from '@nostr/gadgets/lists'
import { useTranslation } from 'react-i18next'
import { useAsync } from 'react-use'

export default function FavoriteRelays({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const channel = useAtomValue(favoritesChannelAtom)
  const { value: fav, loading } = useAsync(() => loadFavoriteRelays(pubkey), [pubkey, channel])

  return (
    <SecondaryPageLink
      to={toFavoriteRelays(pubkey)}
      className="flex gap-1 hover:underline w-fit items-center text-xs"
    >
      {loading ? (
        <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-3" />
      ) : (
        (fav?.items.length ?? 0)
      )}
      <div className="text-muted-foreground">{t('Relay Feeds')}</div>
    </SecondaryPageLink>
  )
}
